export const config = {
  brand: {
    name: "CRUSH",
    slogan: "CRAQUEZ POUR CRUSH.",
    contact_email: "crush.dentifrice.solide@gmail.com",
    instagram: "",
    tiktok: "",
  },
  fonts: { display: "Space Grotesk", body: "Inter" },
  banner: { enabled: true, messages: ["LIVRAISON OFFERTE DÈS 40 €", "OFFRE D'ÉTÉ : −10 % AVEC LE CODE ETE26"] },
  reviews: { global_rating: "4,6", global_count: 225 },
  shipping: {
    flat_rate_eur: 4.90,
    free_threshold_eur: 40,
    free_if_contains: ["kit"],
    countries: ["FR"],
    delay_text: "Expédié sous 48 h — livraison 5 à 7 jours ouvrés",
  },
  guarantee: { enabled: true, text: "Satisfait ou remboursé 30 jours" },
  promo: { stripe_allow_promotion_codes: true, show_promo_field_on_site: false },
  features: { show_cost_per_use: false, bundle: false },
  stock_default: 250,
  products: [
    { id: "kit", route: "/kit", name: "Le Kit Dentaire Complet", short_name: "Le Kit",
      price_eur: 45, anchor_price_eur: null, anchor_label: null,
      stock: 250, variants: ["Menthe", "Fraise"], rating: "4,6", review_count: 114, uses_count: 62,
      image: "/media/kit-01.webp",
      contents: [
        "62 pastilles dentifrice à la nano-hydroxyapatite",
        "62 pastilles bain de bouche — sans alcool",
        "1 brosse à dents en bambou à tête interchangeable",
        "1 boîte de transport compacte",
      ] },
    { id: "pastilles", route: "/pastilles", name: "Pastilles Dentifrice — Recharge", short_name: "Les Pastilles",
      price_eur: 32, anchor_price_eur: null, stock: 250, variants: ["Menthe", "Fraise"],
      rating: "4,6", review_count: 51, uses_count: 62, image: "/media/pastilles-01.webp" },
    { id: "bain-de-bouche", route: "/bain-de-bouche", name: "Pastilles Bain de Bouche", short_name: "Le Bain de Bouche",
      price_eur: 21, anchor_price_eur: null, stock: 250, variants: [], rating: "4,6", review_count: 51, uses_count: 62,
      image: "/media/bdb-01.webp" },
    { id: "brosse", route: "/brosse", name: "Brosse à Dents Bambou", short_name: "La Brosse",
      price_eur: 15, anchor_price_eur: null, stock: 250, variants: [], rating: "4,8", review_count: 9,
      image: "/media/brosse-01.webp" },
  ],
  tracking: { ga4_id: "", meta_pixel_id: "", tiktok_pixel_id: "" },
};

export const getProduct = (id) => config.products.find((p) => p.id === id);

// Navigable product galleries (all photos per product)
export const GALLERIES = {
  kit: ["/media/kit-01.webp", "/media/kit-02.webp", "/media/kit-03.webp", "/media/kit-04.webp", "/media/kit-05.webp", "/media/kit-06.webp", "/media/kit-07.webp"],
  pastilles: ["/media/pastilles-01.webp", "/media/pastilles-02.webp", "/media/pastilles-03.webp", "/media/pastilles-04.webp"],
  "bain-de-bouche": ["/media/bdb-01.webp", "/media/bdb-02.webp", "/media/bdb-03.webp"],
  brosse: ["/media/brosse-01.webp", "/media/brosse-02.webp", "/media/brosse-03.webp"],
};

// Extra cart-only entries (not shown in listings) — the Kit discovery offer.
export const CART_EXTRA = {
  "kit-decouverte": {
    id: "kit-decouverte", name: "Le Kit Dentaire Complet", short_name: "Le Kit",
    price_eur: 39, route: "/kit", image: "/media/kit-01.webp", variants: ["Menthe", "Fraise"],
  },
};
export const getAnyProduct = (id) => getProduct(id) || CART_EXTRA[id];
export const isKitId = (id) => id === "kit" || id === "kit-decouverte";

// Kit offer selector (both are simple one-time purchases — no subscription).
export const KIT_OFFERS = [
  { id: "kit-decouverte", label: "OFFRE DÉCOUVERTE", price: 39, strike: 45, note: "Notre meilleur prix pour un premier kit", shipping_note: "Livraison offerte incluse dans l'offre découverte", badge: "LE PLUS CHOISI", default: true },
  { id: "kit", label: "PRIX HABITUEL", price: 45, strike: null, note: null, shipping_note: null, badge: null },
];

export const img = {
  hero_video: "/media/crush-hero.mp4",
  hero_poster: "/media/crush-hero-poster.jpg",
  enamel: "/media/crush-emducha.webp",
  kit_main: "/media/pastilles-02.webp",
  usage: "/media/crush-usage.webp",
  nha_tech: "/media/crush-nha-poudre.webp",
  nha_macro: "/media/crush-nha-macro.webp",
  nha_poudre: "/media/crush-nha-poudre.webp",
  nha_science: "/media/ingredient-nha-lg.webp",
  founder: "/media/crush-fanny.webp",
};

// Flavor variant thumbnails (green = Menthe, pink = Fraise)
export const VARIANT_IMAGES = {
  Menthe: "/media/variant-menthe.webp",
  Fraise: "/media/variant-fraise.webp",
};

export const reviews = {
  home: [
    { name: "Camille", rating: 5, photo: "/media/avis-camille.webp", title: "Adopté dès le premier essai", text: "J'étais sceptique au début, mais après la première utilisation, j'ai compris. Ça mousse, ça nettoie super bien, et c'est tellement plus agréable que le dentifrice classique." },
    { name: "Léa", rating: 5, photo: "/media/avis-lea.webp", title: "Parfait pour partir léger", text: "Je pars souvent en week-end, et ce kit m'a changé la vie. Plus de tube qui s'écrase, tout rentre dans ma trousse sans fuite ni stress." },
    { name: "Sophie", rating: 5, photo: "/media/avis-sophie.webp", title: "Bluffant !", text: "Je n'aurais jamais cru qu'une petite pastille puisse remplacer mon tube de dentifrice. Ça mousse bien, ça nettoie vraiment, et ma bouche reste fraîche." },
    { name: "Lucie", rating: 5, photo: "/media/avis-lucie.webp", title: "Révolutionnaire !", text: "Je n'aurais jamais pensé qu'on pouvait faire du bain de bouche en pastille. Pourtant ça fonctionne parfaitement. Bouche fraîche, haleine impeccable, et plus de flacon plastique." },
    { name: "Yasmine", rating: 5, photo: "/media/avis-yasmine.webp", title: "Génialissime", text: "Depuis que j'utilise ces pastilles, mes dents sont plus blanches et l'haleine fraîche toute la journée !" },
    { name: "Antoine", rating: 5, photo: "/media/avis-maxime.webp", title: "Adopté en famille", text: "On a tous adopté. Même mon mari qui était sceptique au départ est conquis. La fraîcheur est au rendez-vous et le geste écolo nous plaît à tous." },
  ],
  kit: [
    { name: "Camille", rating: 5, title: "Adopté dès le premier essai", text: "J'étais sceptique au début, mais après la première utilisation, j'ai compris. Ça mousse, ça nettoie super bien, et c'est tellement plus agréable que le dentifrice classique.", product: "Kit" },
    { name: "Léa", rating: 5, title: "Parfait pour partir léger", text: "Je pars souvent en week-end, et ce kit m'a changé la vie. Plus de tube qui s'écrase, tout rentre dans ma trousse sans fuite ni stress.", product: "Kit" },
    { name: "Marc", rating: 5, title: "Le futur du dentifrice", text: "Quand je vois le nombre de tubes de dentifrice que j'ai jetés dans ma vie… Cette innovation est vraiment nécessaire. Le geste écologique devient un plaisir.", product: "Kit" },
  ],
  pastilles: [
    { name: "Camille", rating: 5, title: "Zéro déchet, zéro compromis", text: "J'avais peur que l'efficacité soit moindre qu'un dentifrice classique. Pas du tout ! Les dents sont nickel et je n'ai plus de tube plastique.", product: "Pastilles" },
    { name: "Julien", rating: 5, title: "Très bonne formule", text: "La formule est vraiment bien travaillée. Pas d'ingrédients douteux, goût agréable, efficacité au rendez-vous.", product: "Pastilles" },
    { name: "Louis", rating: 5, title: "Parfait pour ma routine zéro déchet", text: "Je fais le tour de ma salle de bain pour réduire le plastique et ces pastilles s'inscrivent parfaitement. Efficaces et bien pensées.", product: "Pastilles" },
  ],
  "bain-de-bouche": [
    { name: "Lucie", rating: 5, title: "Révolutionnaire !", text: "Je n'aurais jamais pensé qu'on pouvait faire du bain de bouche en pastille. Pourtant ça fonctionne parfaitement. Bouche fraîche, haleine impeccable, et plus de flacon plastique.", product: "Bain de bouche" },
    { name: "Pierre", rating: 5, title: "Goût frais et naturel", text: "Pas d'alcool agressif, pas de goût chimique. Le bain de bouche est doux, frais et efficace. Exactement ce que je cherchais.", product: "Bain de bouche" },
    { name: "Romain", rating: 5, title: "Hygiène parfaite", text: "Je l'utilise matin et soir depuis deux mois. Mes gencives vont mieux, mon haleine est fraîche. Très satisfait.", product: "Bain de bouche" },
  ],
  brosse: [
    { name: "Mohamed", rating: 5, photo: "/media/avis-mohamed.webp", title: "Tête durable", text: "Après 3 mois d'utilisation, les poils sont toujours comme neufs. Excellente qualité.", product: "Brosse" },
    { name: "Émilie", rating: 5, title: "Écologique", text: "Brosse en bambou avec tête rechargeable. L'impact écologique est minime.", product: "Brosse" },
    { name: "Isabelle", rating: 5, title: "Mes enfants adorent", text: "Ma fille de 6 ans adore la petite tête colorée. Le brossage devient un jeu.", product: "Brosse" },
  ],
};

export const ingredients = [
  { name: "Nano-hydroxyapatite", tag: "l'émail", image: "/media/ingredient-nha.webp", text: "Constituant naturel de l'émail (particules de 20–80 nm) qui se dépose dans les microfissures de surface et contribue à la reminéralisation. Réduit la sensibilité, ravive l'éclat — sans fluor." },
  { name: "Xylitol", tag: "l'équilibre", image: "/media/ingredient-xylitol.webp", text: "Sucre de bouleau reconnu en hygiène bucco-dentaire, contribue à limiter les bactéries responsables des caries." },
  { name: "Sodium Cocoyl Glutamate", tag: "la mousse", image: "/media/ingredient-coco.webp", text: "Tensioactif doux d'origine naturelle (coco), pour la mousse au brossage." },
  { name: "Gomme de caroube", tag: "la texture", image: "/media/ingredient-caroube.webp", text: "Liant végétal issu du caroubier." },
  { name: "Carbonate de calcium", tag: "le nettoyage", image: "/media/ingredient-calcium.webp", text: "Minéral qui soutient l'action mécanique du brossage." },
  { name: "Citrate de zinc", tag: "le tartre", image: "/media/ingredient-zinc.webp", text: "Contribue à limiter la plaque, propriétés apaisantes." },
  { name: "Menthol", tag: "la fraîcheur", image: "/media/ingredient-menthe.webp", text: "Naturellement présent dans la menthe." },
];

// Shown only on the Fraise flavor (kit & pastilles)
export const fraiseIngredient = { name: "Extrait de fraise", tag: "le goût", image: "/media/ingredient-fraise.webp", text: "Arôme naturel de fraise, pour une version gourmande du brossage." };

export const studies = [
  { meta: "Adultes · 18 mois · 189 participants", text: "Essai randomisé en double aveugle : dentifrice à l'hydroxyapatite sans fluor vs dentifrice fluoré 1450 ppm. 89,3 % du groupe hydroxyapatite sans nouvelle atteinte carieuse, contre 87,4 % pour le fluor. Non-infériorité démontrée. (Frontiers in Public Health, 2023 · essai NCT04756557)", url: "https://www.frontiersin.org/journals/public-health/articles/10.3389/fpubh.2023.1199728/full" },
  { meta: "Enfants · 1 an · 207 participants", text: "Essai randomisé en double aveugle, hydroxyapatite vs fluor sur l'apparition de caries précoces. Pas d'infériorité de l'hydroxyapatite. (2021)", url: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7846568/" },
  { meta: "Patients orthodontiques à haut risque · 6 mois", text: "Population très susceptible aux caries (appareils) : pas de différence significative entre hydroxyapatite et fluor 1400 ppm. (essai NCT02705456)", url: "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6590169/" },
];

export const timeline = [
  { year: "1960s", text: "NASA, Cambridge. La reproduction cristalline de l'hydroxyapatite est mise au point pour contrer la perte osseuse des astronautes en apesanteur." },
  { year: "1970", text: "Le brevet est transféré à Sangi Co. (Japon)." },
  { year: "1980", text: "Lancement du premier dentifrice à la nano-hydroxyapatite au monde." },
  { year: "1993", text: "Le Japon reconnaît officiellement la nHA comme agent anticarie." },
  { year: "2026", text: "CRUSH. La même technologie, en pastille. Sans tube, sans fluor." },
];
